// Javascript
import Swiper, { Autoplay, Navigation, Pagination, Thumbs, EffectFade } from 'swiper';
import ScrollOut from 'scroll-out';

// Scripts to fire once the DOM has loaded
document.addEventListener('DOMContentLoaded', () => {

    // Mobile navigation (global)
    var nav = document.querySelector('[data-nav]');
    var navTrigger = document.querySelector('[data-nav-trigger]');
    var navPanelTriggers = document.querySelectorAll('[data-nav-panel-trigger]');

    if(navTrigger){
        navTrigger.addEventListener('click', function() {
            navTrigger.classList.toggle('burger-icon--active');
            nav.classList.add('mobile--transition');
            nav.classList.toggle('mobile--active');
            document.body.classList.toggle('nav-active');
            document.body.classList.toggle('overflow-hidden');
        });
    }

    if (navPanelTriggers) {
        navPanelTriggers.forEach(function(panelTrigger) {
            panelTrigger.addEventListener('click', (event) => {
                event.preventDefault();
                const panelId = event.currentTarget.dataset.navPanelTrigger;
                const panel = document.getElementById(`mobile-panel-${panelId}`);
                panel.classList.toggle('mobile-panel--active');
            });
        });
    }


    // Desktop second level
    // var links = document.querySelectorAll('.dropdown-nav__item--children');
    // if (links) {
    //     links.forEach(function(link) {
    //         link.addEventListener('mouseover', (event) => {
    //             const dropdown = event.currentTarget.querySelector('.secondary-dropdown-nav');
    //             dropdown.classList.add('secondary-dropdown-nav--active');
    //         });
    //     });
    // }

	
    // Scroll effects (global)
    ScrollOut({
        targets: '[data-scroll]',
        once: true,
        threshold: 0.5
    });


    // Accordions
    // Used globally on mobile navigation, footer and accordion block
    // If there is an accordion inside an accordion then data-accordion-allow-multiple needs to be used
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    if (accordionItems.length) {
        accordionItems.forEach(function(accordion) {
            const accordionLink = accordion.querySelector('[data-accordion-link]').firstElementChild;
            accordionLink.addEventListener('click', toggleAccordion);
        });
    }

    function toggleAccordion(e) {
        const link = e.target.closest('[data-accordion-link]');
        const parent = link.closest('[data-accordion]');
        const content = parent.querySelectorAll('[data-accordion-content]');

        content.forEach(function(content) {
            if (content.previousElementSibling === link) {
                content.classList.toggle('is-active');
                link.classList.toggle('is-active');
                link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
                content.setAttribute('aria-hidden', content.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
            }
            else {
                if(!("accordionAllowMultiple" in content.parentNode.dataset)) {
                    content.classList.remove('is-active');
                    content.previousElementSibling.classList.remove('is-active');
                    content.previousElementSibling.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }


    // Gallery block carousel
    Swiper.use([Thumbs, Navigation, Pagination]);

    const galleryThumbs = new Swiper('[data-gallery-thumbs]', {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '[data-gallery-thumbs-next]',
            prevEl: '[data-gallery-thumbs-prev]',
        },
        on: {
            slideChange: function() {
                stopVideo()
            }
        },
    });

    const gallery = new Swiper('[data-gallery]', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
            swiper: galleryThumbs,
        },
        pagination: {
            el: '[data-gallery-pagination]',
            type: 'fraction',
        },
        navigation: {
            nextEl: '[data-gallery-next]',
            prevEl: '[data-gallery-prev]',
        },
        on: {
            slideChange: function() {
                stopVideo()
            }
        },
    });

    // Stop videos
    function stopVideo() {
        const iframes = document.querySelectorAll('iframe');

        if (iframes){
            iframes.forEach(function(iframe) {
                iframe.remove();
            });
        }
    }


    // Search
    // Force minimum length for search
    const searchField = document.getElementById('SearchForm_SearchForm_Search');
    if(searchField){
        searchField.setAttribute('minlength', 2);
    }
    // Placeholder text for mobile
    const searchMobileInput = document.querySelector('.search--mobile #SearchForm_SearchForm_Search');
    searchMobileInput.placeholder = 'Search';
    
    const searchButton = document.querySelector('[data-search-open]');
    const searchForm = document.querySelector('.search--desktop');

    searchButton.addEventListener('click', (event) => {
        searchForm.classList.toggle('search--desktop--active');
    })


    // Generic cookie functions
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = 'expires='+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ';' + expires + ';path=/';
    }

    function getCookie(cname) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let notificationBanner = document.querySelector('#notification-banner');
    if(notificationBanner){
        let timestamp = parseInt(Date.now() / 1000); // convert to seconds to be compatible with php
        let bannerCloseBtn = document.querySelector('#notification-banner-close');
        bannerCloseBtn.addEventListener('click', function(e){
            e.preventDefault();

            // set the cookie value is current timestamp
            setCookie('notification_closed', timestamp, 365);
            // close the notification banner
            notificationBanner.classList.add('hidden');
        });
    }
});